// mobileConsole.js
'use strict';
import loadScriptTag from '../resource/loadScriptTag.js';
import { getIsOnWebviewApp } from '../resource/getUserAgent.js';
import { getIsInNext } from '../resource/getJsEnvironment.js';

const isOnWebviewApp = getIsOnWebviewApp();
const isInNextApp = getIsInNext();

const ERUDA_SCRIPT_ID = 'eruda-script';
const ERUDA_CDN_URL =
  isOnWebviewApp || !isInNextApp
    ? '/static/js/mobile-console.js'
    : '/mobile-console.js';

let loadErudaScriptPromise;

/**
 * Initializes the Eruda mobile console
 * @async
 * @param {Object} [options={}] - Configuration options for Eruda
 * @returns {Promise<void>}
 */
const initEruda = async (options = {}) => {
  await loadErudaScript();

  if (window.eruda) {
    window.eruda.init(options);

    // set eruda position to the right center of the screen
    window.eruda.position({ y: window.innerHeight / 2 });
  }
};

/**
 * Destroys the Eruda mobile console instance
 * @returns {void}
 */
const destroyEruda = () => {
  if (window.eruda) {
    window.eruda.destroy();
  }
};

/**
 * Loads the Eruda script from CDN if not already loaded
 * @async
 * @private
 * @returns {Promise<void>}
 */
const loadErudaScript = async () => {
  if (loadErudaScriptPromise) return loadErudaScriptPromise;

  try {
    loadErudaScriptPromise = loadScriptTag({
      id: ERUDA_SCRIPT_ID,
      src: ERUDA_CDN_URL,
      async: true,
    });

    await loadErudaScriptPromise;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to load Eruda mobile console:', error);
  }
};

/**
 * Checks if the Eruda mobile console is initialized
 * @returns {boolean} - True if Eruda is initialized, false otherwise
 */
const isErudaInitialized = () => {
  if (typeof window === 'undefined') return false;

  return window.eruda?._isInit;
};

export { initEruda, destroyEruda, isErudaInitialized };
